import { NavLink, useLocation } from "react-router-dom";
import { Home, Library, Dumbbell, User, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/", label: "Home", icon: Home, testid: "nav-home", end: true },
  { to: "/library", label: "Library", icon: Library, testid: "nav-library" },
  { to: "/practice", label: "Practice", icon: Dumbbell, testid: "nav-practice" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const nav = [...items];
  if (user?.role === "admin") {
    nav.push({ to: "/admin", label: "Admin", icon: Shield, testid: "nav-admin" });
  }

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[#222A38] bg-[#0B0E14]/95 backdrop-blur-xl md:hidden"
    >
      <div className="grid grid-flow-col auto-cols-fr px-1 pb-[env(safe-area-inset-bottom)]">
        {nav.map((item) => {
          const active = item.end
            ? location.pathname === "/"
            : location.pathname.startsWith(item.to);
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className="flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors"
            >
              <span
                className={`flex h-9 w-14 items-center justify-center rounded-full transition-all ${
                  active ? "bg-cyan-500/15 text-cyan-400 shadow-[0_0_16px_rgba(6,182,212,0.25)]" : "text-slate-500"
                }`}
              >
                <Icon size={20} strokeWidth={active ? 2.4 : 2} />
              </span>
              <span className={active ? "text-cyan-400" : "text-slate-500"}>{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}

export function SideNav() {
  const { user } = useAuth();
  const location = useLocation();
  const nav = [...items];
  if (user?.role === "admin") {
    nav.push({ to: "/admin", label: "Admin", icon: Shield, testid: "sidenav-admin" });
  }
  return (
    <aside className="hidden md:flex md:w-60 md:flex-col md:border-r md:border-[#222A38] md:bg-[#0B0E14] md:fixed md:inset-y-0 md:z-30">
      <div className="flex items-center gap-2.5 px-6 py-6">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400 to-violet-500 font-display text-lg font-extrabold text-[#0B0E14]">
          S
        </div>
        <div>
          <div className="font-display text-lg font-extrabold leading-none tracking-tight text-white">SONGWISE</div>
          <div className="font-mono-sw text-[9px] uppercase tracking-[0.2em] text-cyan-400">AI Studio</div>
        </div>
      </div>
      <div className="mt-2 flex flex-col gap-1 px-3">
        {nav.map((item) => {
          const active = item.end ? location.pathname === "/" : location.pathname.startsWith(item.to);
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`side-${item.testid}`}
              className={`flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${
                active ? "bg-cyan-500/10 text-cyan-300" : "text-slate-400 hover:bg-white/5 hover:text-slate-200"
              }`}
            >
              <Icon size={18} />
              {item.label}
            </NavLink>
          );
        })}
      </div>
      <div className="mt-auto px-6 py-6 text-[10px] font-mono-sw uppercase tracking-wider text-slate-600">
        Listen · Separate · Understand · Learn
      </div>
    </aside>
  );
}
